import { cn } from "@/utils/cn";
import { WIZARD_STEPS, type WizardStep } from "./formUtils";

export function SolicitacaoPagamentoStepper({
  currentStep,
}: {
  currentStep: WizardStep;
}) {
  return (
    <div className="w-full">
      <div className="flex items-start justify-between gap-2">
        {WIZARD_STEPS.map(({ step, label }, index) => {
          const done = step < currentStep;
          const active = step === currentStep;
          return (
            <div key={step} className="flex flex-1 flex-col items-center min-w-0">
              <div className="flex w-full items-center">
                {index > 0 && (
                  <div
                    className={cn(
                      "h-0.5 flex-1",
                      done || active ? "bg-brand-600" : "bg-slate-200",
                    )}
                  />
                )}
                <div
                  className={cn(
                    "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-bold border-2",
                    done && "bg-brand-600 border-brand-600 text-white",
                    active && "bg-white border-brand-600 text-brand-700",
                    !done && !active && "bg-white border-slate-200 text-slate-400",
                  )}
                >
                  {step}
                </div>
                {index < WIZARD_STEPS.length - 1 && (
                  <div
                    className={cn(
                      "h-0.5 flex-1",
                      done ? "bg-brand-600" : "bg-slate-200",
                    )}
                  />
                )}
              </div>
              <p
                className={cn(
                  "mt-2 text-[11px] sm:text-xs font-semibold uppercase tracking-wide text-center leading-tight",
                  active ? "text-brand-700" : done ? "text-slate-600" : "text-slate-400",
                )}
              >
                {label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
